import { Tooltip } from "react-tooltip";
export default function MenuButton(props) {
  const getFontWeight = () =>
    `${props.active ? "secondary-bold-text" : "secondary-regular-text"}`;

  const allowedCursor = () => `${props.disabled ? "cursor-not-allowed" : ""}`;

  const addCustomClass = () => `${props.customClass ? props.customClass : ""}`;

  const getCircleButtonColor = () =>
    `${
      props.active
        ? "circle-button-gradient-blue"
        : "circle-button-gradient-gray"
    }`;

  const getCircleButtonColorDisabled = () =>
    `${
      props.disabled
        ? "circle-button-gradient-gray-disabled cursor-not-allowed"
        : ""
    }`;

  const isProfileButton = () => `${props.id === "profile" ? "p-0" : "p-[1rem]"}`;

  return (
    <>
      <a
        className={`ltr-div h-content flex cursor-pointer flex-col items-center justify-between text-xs
        ${getFontWeight()} ${addCustomClass()} ${allowedCursor()} ${props?.className}`}
        href={props.href}
        id={props?.id}
      >
        <div
          className={`flex h-12 w-12 items-center justify-center rounded-full ${isProfileButton()}
          ${getCircleButtonColor()} ${getCircleButtonColorDisabled()}`}
        >
          {props.icon}
        </div>
        <span className="mt-2">{props.label}</span>
        {props.tooltip && (
          <Tooltip
            anchorId={props?.id}
            content={props?.tooltip}
            className="tooltip"
            place="top"
            type="dark"
            effect="solid"
          />
        )}
      </a>
    </>
  );
}
